// import { useLoader } from "@react-three/fiber";
// import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { const_var } from "../../../../../redux/reducers/reducer";


const HandleTwoModel =  ({ handleModel}) => {
    // const baseUrl = process.env.REACT_APP_BASE_URL;
    // const { nodes } = useLoader(GLTFLoader, baseUrl+'/assets/glbModels/handle_rect_group.glb');

    
    return (
        <>
            {new Array(2).fill("").map((_, index) =>
                <group key={`outer-handle-model-${index}`} name='outer-handle' position={[Math.pow(-1, index) * 0.2, 0, 0.25]} scale={[0.02, 0.02, 0.02]}>
                    <mesh geometry={const_var.loadGltObj1?.black_section.geometry}>
                        <meshStandardMaterial color={'#606060'} roughness={0.2} metalness={0.3} />
                    </mesh>
                    <mesh geometry={const_var.loadGltObj1?.white_section.geometry}>
                        <meshStandardMaterial color={'#BEBEBE'} roughness={0.2} metalness={0.3} />
                    </mesh>
                    <mesh geometry={const_var.loadGltObj1?.handle.geometry} position={[0, 10.25, 2]} rotation={[0, 0, Math.PI * index]}>
                        <meshStandardMaterial color={'#BEBEBE'} roughness={0.2} metalness={0.5} />
                    </mesh>
                </group>
            )}
            {new Array(2).fill("").map((_, index) =>
                <group key={`inner-handle-model-${index}`} name='inner-handle' position={[Math.pow(-1, (index + 1)) * 0.2, 0, 0.05]} rotation={[0, Math.PI, 0]} scale={[0.02, 0.02, 0.02]}>
                    <mesh geometry={const_var.loadGltObj1?.black_section.geometry}>
                        <meshStandardMaterial color={'#606060'} roughness={0.2} metalness={0.3} />
                    </mesh>
                    <mesh geometry={const_var.loadGltObj1?.white_section.geometry}>
                        <meshStandardMaterial color={'#BEBEBE'} roughness={0.2} metalness={0.3} />
                    </mesh>
                    <mesh geometry={const_var.loadGltObj1?.handle.geometry} position={[0, 10.25, 2]} rotation={[0, 0, Math.PI * index]}>
                        <meshStandardMaterial color={'#BEBEBE'} roughness={0.2} metalness={0.5} />
                    </mesh>
                </group>
            )}
        </>
    )
}

export default HandleTwoModel;